export const IDLE = 'idle';
export const LOADING = 'loading';
export const LOADING_ERROR = 'loading-error';